// Use relative URLs so API calls always go to the same domain as the page.
// The Kubernetes ingress routes /api/* to the backend automatically.
// This prevents CORS issues when using custom domains.
export const API_URL = '';
